// Copyright (c) 2025 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

import iscAbiAsText from '../assets/ISCSandbox.abi?raw';

export const iscAbi = JSON.parse(iscAbiAsText);
